import { type SxProps, type Theme } from '@mui/material'

/** Shared chrome for the collection wizard steps (Getting Started → Program Status → Buildings Without). */
export const stepStyles = {
  intro: {
    mb: '24px'
  } satisfies SxProps<Theme>,
  sections: {
    display: 'flex',
    flexDirection: 'column',
    gap: '56px'
  } satisfies SxProps<Theme>,
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px'
  } satisfies SxProps<Theme>,
  formField: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  } satisfies SxProps<Theme>,
  fieldText: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  } satisfies SxProps<Theme>,
  select: {
    maxWidth: '480px',
    '& .MuiSelect-icon': { color: 'var(--grey-300)' }
  } satisfies SxProps<Theme>,
  selectPlaceholder: {
    color: 'var(--grey-500)'
  } satisfies SxProps<Theme>,
  selectMenu: {
    maxHeight: '288px',
    border: '1px solid var(--grey-200)',
    borderRadius: '6px',
    boxShadow: '0.5px 1.5px 7px rgba(26, 26, 26, 0.08)'
  } satisfies SxProps<Theme>,
  checkList: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  } satisfies SxProps<Theme>,
  checkRow: {
    display: 'flex',
    alignItems: 'center',
    minHeight: '48px',
    px: '16px'
  } satisfies SxProps<Theme>,
  checkLabel: {
    fontFamily: 'Open Sans',
    fontSize: '16px',
    fontWeight: 500,
    color: 'var(--grey-900)'
  } satisfies SxProps<Theme>,
  optionalTag: {
    fontStyle: 'italic',
    color: 'var(--grey-500)'
  } satisfies SxProps<Theme>,
  textArea: {
    maxWidth: '750px',
    '& .MuiFilledInput-root': { minHeight: '110px' }
  } satisfies SxProps<Theme>,
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    mt: '56px'
  } satisfies SxProps<Theme>,
  continueButton: {
    ml: 'auto'
  } satisfies SxProps<Theme>
}
